/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArbeitszeitkontoDto } from '../../models/arbeitszeitkonto-dto';

export interface GetAggregiertesArbeitszeitkontoForMitarbeiter$Json$Params {

/**
 * ID des Mitarbeiters
 */
  mitarbeiterId: string;

/**
 * Monat. Nur Jahr und Monat werden beachtet
 */
  monat: string;
}

export function getAggregiertesArbeitszeitkontoForMitarbeiter$Json(http: HttpClient, rootUrl: string, params: GetAggregiertesArbeitszeitkontoForMitarbeiter$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ArbeitszeitkontoDto>> {
  const rb = new RequestBuilder(rootUrl, getAggregiertesArbeitszeitkontoForMitarbeiter$Json.PATH, 'get');
  if (params) {
    rb.path('mitarbeiterId', params.mitarbeiterId, {});
    rb.path('monat', params.monat, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ArbeitszeitkontoDto>;
    })
  );
}

getAggregiertesArbeitszeitkontoForMitarbeiter$Json.PATH = '/v1/mitarbeiter/{mitarbeiterId}/arbeitszeitkonten/{monat}/aggregiert';
